// extracted by mini-css-extract-plugin
export default {"row":"confirm-transaction_row__p54CA","fullWidth":"confirm-transaction_fullWidth__Br0aG"};